import React, { useEffect } from "react";
import { useCart } from "../components/Carts/useCart";
import { useAuth } from "../components/Auth/useAuth";
import { useVrpRedirect } from "../components/Auth/useVrpRedirect";
import { Container, Row, Col } from "react-bootstrap";
import { navigate } from "../routes";
import OrderSynthese from "../components/Orders/OrderSynthese";
import Page from "../components/Page/Page";
import useTranslations from "../components/Translations/useTranslations";
import ApplicationHeader from "../components/Headers/ApplicationHeader/ApplicationHeader";
import { admin } from '../routes/admin';

function FinishOrderPage() {
  const [{ user }] = useAuth();
  useVrpRedirect();
  const [_, cartSDK] = useCart(user.client_profile?.id);

  useEffect(() => {
    window.addEventListener("popstate", _handleGoBack);

    return () => {
      window.removeEventListener("popstate", _handleGoBack);
    };
  }, []);

  const _handleGoBack = (e) => {
    // if (window.confirm(trl.message("FinishOrderPage.backAction"))) {
    cartSDK.removeOrderHeader({ creator: user.client_profile?.id });
    navigate.goBack();
    // }
  };

  return (
    <React.Fragment>
      <ApplicationHeader headerConfig={{ showcart: true }} />
      <Page>
        <Container>
          <Row className="justify-content-center">
            <Col>
              <OrderSynthese goBack={_handleGoBack} />
            </Col>
          </Row>
        </Container>
      </Page>
    </React.Fragment>
  );
}

export default FinishOrderPage;
